export default "__VITE_ASSET__DBYRYR46__$_?nuxt_component=async&nuxt_component_name=SvgoOnboardingInvestor&nuxt_component_export=default__"